// @ts-strict-ignore
import {
  createReducer,
  keyValueSetReducer,
  keyValueUpdateReducer,
} from '../../redux/helpers/redux-helpers'
import { FsCore } from '../../types/fs-core'
import {
  setPageOffset,
  setProductTable,
  SetProductTablePayload,
  updateProductTable,
  UpdateProductTablePayload,
} from './product-table-actions'

export const productTablesReducer = createReducer<FsCore.ESProductTablesState>(
  {
    [setProductTable]: (state, { id, productTable }: SetProductTablePayload) =>
      keyValueSetReducer(state, id, productTable),
    [setPageOffset]: (state, { id, pageOffset }) => {
      return keyValueUpdateReducer(state, id, {
        pageOffset,
      })
    },
    [updateProductTable]: (state, { id, pageOffset, selectedSort }: UpdateProductTablePayload) => {
      const updatedTable: FsCore.ESProductTableState = {
        ...state[id],
        pageOffset,
        sorts: {
          ...state[id].sorts,
          selectedSort,
        },
      }
      return keyValueSetReducer(state, id, updatedTable)
    },
  },
  {},
)
